import request from '@/axios'

// 商品详情
export function getDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/virtual_product/product/getDetail',
    method: 'post',
    data
  })
}

// 商品下订

export function saveOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/virtual_product/order/saveOrder',
    method: 'post',
    data
  })
}

// 虚拟商品下订渠道

export function getVirtualChannels(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/virtual_product/order/getVirtualChannels',
    method: 'post',
    data
  })
}
